// src/unicodex_ui/services/identityApi.js
import api from "./apiClient";

/**
 * Submit manufacturer prefix application.
 * POST /api/identity/applications
 */
export async function submitApplication(payload) {
  const res = await api.post("/api/identity/applications", payload);
  return res.data; // { ok: true, application: {...} } or { ok: false, ... }
}

/**
 * Verify UCX code.
 * POST /api/identity/verify
 */
export async function verifyCode(payload) {
  const res = await api.post("/api/identity/verify", payload);
  return res.data; // { ok: true, result: {...} }
}